import { Sprite, Text } from 'pixi.js'

export enum PriceChangePercentage {
  HOUR = 'priceChange1',
  FOUR_HOURS = 'priceChange4',
  TWELVE_HOURS = 'priceChange12',
  DAY = 'priceChange24',
}

export type Circle = {
  id: string
  x: number
  y: number
  vx: number
  vy: number
  color: string
  dragging: boolean
  targetRadius: number
  symbol: string
  coinName: string
  radius: number
  isSearched: boolean
  graphicSprite: Sprite | null
  [PriceChangePercentage.HOUR]: number
  [PriceChangePercentage.FOUR_HOURS]: number
  [PriceChangePercentage.TWELVE_HOURS]: number
  [PriceChangePercentage.DAY]: number
  image: string
  text2: Text | null
}
